import React, { memo } from "react";

import Icon from "app/components/Icon/Icon";
import { ReactComponent } from "./svgs/inconclusive_ratio.svg";

export const InconclusiveRatioIcon = memo(() => {
  return <Icon component={ReactComponent} />;
});
